/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleUpIcon16Light = forwardRef('ArrowFigureACircleUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.5 11a.5.5 0 0 1-.5-.5V5.38L5.384 7.32a.5.5 0 1 1-.768-.64L6.348 4.6a1.5 1.5 0 0 1 2.304 0l1.732 2.078a.5.5 0 0 1-.768.64L8 5.382v5.118a.5.5 0 0 1-.5.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 14a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13ZM2 7.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 0 0-11 0Z" })));
});
